//トップページ　キービジュアルスライダー
import 'jquery.easing';
export function idxFunc() {
    let indexTop = $('#indexTop').length;
    
    if (indexTop) {

            let resizecheck = $('#responsibleCheck').width();

            $(window).on('resize', function () {
                resizecheck = $('#responsibleCheck').width();
            });
        
            let accordionBtn = $('.selectBrandList .accordionBtn');
            let product = $('.selectBrandList .product');

            accordionBtn.click(function(){
                if (resizecheck == '2') {
                    if ($(this).hasClass('isOpen')) {
                    $(this).removeClass('isOpen');
                    $(this).next('dd').stop().css('height','auto').slideUp(500);
                    }
                    else {
                        accordionBtn.removeClass('isOpen');
                        $(this).addClass('isOpen');
                        accordionBtn.next('dd').stop().css('height','auto').slideUp(500);
                        $(this).next('dd').stop().css('height','auto').slideDown(500);
                    }
                }
            });
        
            let selectBrandList = $('.selectBrandList');
        
            selectBrandList.on({
                'mouseenter': function () {
                    if (resizecheck == '1') {
                        $(this).addClass('is');
                        $(this).find('dt').addClass('isOpen');
                        $(this).find('dd').stop().css('height','auto').slideDown(500);
                    }
                },
                'mouseleave': function () {
                    if (resizecheck == '1') {
                        if ($(this).not().hasClass('is')) {
                            $(this).find('dt').removeClass('isOpen');
                            $(this).find('dd').stop().hide();
                            $(this).removeClass('is');
                        } else {
                            $(this).find('dt').removeClass('isOpen');
                            $(this).find('dd').stop().slideUp(500);
                        }
                    }
                }
            });
        
            $("body").on({
                'mouseleave': function () {
                    if (resizecheck == '1') {
                        selectBrandList.find('dt').removeClass('isOpen');
                        selectBrandList.find('dd').stop().slideUp(500);
                        selectBrandList.removeClass('is');
                    }
                }
            });
        
            product.click(function(){
                accordionBtn.removeClass('isOpen');
                accordionBtn.next('dd').slideUp(500);
                
                let id = $(this).attr('id');
                let area = $('article.' + id);
                let position = area.offset().top;
                
                $("html,body").animate({
                    scrollTop: position
                }, 1200, 'easeInOutQuint');
                return false;
            });
    }
}